import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/cfr-pfr-params'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  update: NoParamEndpointConstructor
}

export const cfrDefaultParamsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  update: () => baseUrl,
}
